
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import Karteieintrag from '@/types/Karteieintrag';
    import Patient from '@/types/Patient';
    import { Satzart } from '@/types/Satzart';
    import { DataTableHeaders } from '@/types';
    import { mapGetters } from 'vuex';

    export type KarteiFilter = {
        satzarten: number[];
    }

    @Component({
        computed: {
            ...mapGetters('authentication', ['isAllowed', 'getSystemEinstellung']),
        },
    })
    export default class Kartei extends Vue {
        @Prop() impfungen!: Karteieintrag[];
        @Prop() patient!: Patient;
        @Prop() loading!: boolean;
        @Prop() visible!: boolean;
        @Prop() filterProp!: KarteiFilter;

        public $refs!: {
            table: Vue;
        };

        public search = '';
        public expanded: Karteieintrag[] = [];

        public filter: KarteiFilter = {
            satzarten: [Satzart.Impfung],
        };

        public Satzart = Satzart;

        public get headers(): DataTableHeaders<Karteieintrag, 'status' | 'data-table-expand'> {
            return [
                { text: '', value: 'status', sortable: false, width: 70, align: 'center' },
                { text: 'Datum', value: 'impfdatumDisplay', width: 110 },
                { text: 'Text', value: 'textDisplay' },
                { text: 'Arzt', value: 'aerzte_arzt' },
                /*{ text: 'Impfstelle', value: 'impfstelle_bezeichnung' },*/
                { text: '', value: 'data-table-expand' },
            ];
        }

        public tableHeight = 500;

        public mounted(): void {
            this.filter = this.filterProp;
            this.$nextTick(() => this.onResize());
        }

        public onResize(): void {
            this.tableHeight = (this.$refs.table?.$parent?.$parent?.$parent?.$el?.clientHeight ?? 500) - 170;
        }

        public updated(): void {
            this.filter = this.filterProp;

            if (this.$refs.table) {
                this.$refs.table.$el.scrollTop = 0;
            }
        }

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (!visible) {
                this.expanded = [];
            }
        }

        @Watch('filter', { deep: true })
        public onChangeFilter(): void {
            this.$emit('change', this.filter);
            this.$emit('update:filterProp', this.filter);
            this.expanded = [];
        }

        public onClickFilter(all: boolean): void {
            this.search = '';
            this.filter.satzarten = all ? Satzart.values() : [];

            this.onChangeFilter();
        }

        public onClickExpand(eintrag: Karteieintrag): void {
            if (this.expanded.length === 0) {
                this.expanded = [eintrag];
            } else {
                if (this.expanded.indexOf(eintrag) !== -1) {
                    this.expanded = [];
                } else {
                    this.expanded = [eintrag];
                }
            }
        }

        public getTextDisplayClasses(eintrag: Karteieintrag): string {
            switch (eintrag.satzart) {
                case Satzart.Plan:
                    return 'text-plan';
                case Satzart.Impfung:
                    return '';
                case Satzart.Leistung:
                    return 'text-leistung';
                case Satzart.Text:
                    return 'text-text text-truncate dots';
                case Satzart.Untersuchung:
                    return 'text-untersuchung';
                case Satzart.Diagnose:
                    return 'text-diagnose';
                /* case Satzart.Anamnese:
                     return 'text-anamnese';*/
                case Satzart.Brief:
                    return 'text-brief';
                case Satzart.Rezept:
                    return 'text-rezept';
                default:
                    return '';
            }
        }
    }
